import { reactive, set, toRefs, computed } from '@vue/composition-api'
import Vue from 'vue'
import _ from 'lodash'
import httpService from '@/core/http-service'

export default function useNodeHierarchy(getChildren = () => []) {
  const state = reactive({
    nodeData: {},
    selectedNodeData: {},
    initialized: false
  })

  const selectionNames = computed(() => _.chain(state.nodeData).map((val) => val.node.name).filter(val => !!val).value())
  const hasSelections = computed(() => _.keys(state.nodeData).length > 1)
  const lastLevel = computed(() => _.last(_.keys(state.nodeData)))
  const deepestNodeSelection = computed(() => {
    return state.nodeData[lastLevel.value] ? state.nodeData[lastLevel.value].node : null
  })
  const isModelSelected = computed(() => deepestNodeSelection.value.isModel)
  const hasChanges = computed(() => {
    return state.selectedNodeData && !_.isEqual(state.nodeData, state.selectedNodeData)
  })
  const endOfNodeHierarchy = computed(() => _.get(state.nodeData[lastLevel.value], ['children', 'length']) === 0)

  async function prePopulateSelections(codes) {
    for (const [i, code] of codes.entries()) {
      const selectedNode = _.find(state.nodeData[i].children, node => node.code === code)
      const data = await getChildren(code)
      set(state.nodeData, i + 1, { node: selectedNode, children: data })
    }
  }

  async function getNodeCodeHierarchy(code) {
    const { data } = await httpService.get(`vehicle/hierarchy/${code}`)
    return data
  }

  async function addLevel(node, currentLevel) {
    const nextLevel = Number(currentLevel) + 1
    resetLowerLevels(nextLevel)
    const data = await getChildren(node.code)
    set(state.nodeData, nextLevel, { node: node, children: data })
  }

  function resetLowerLevels(level) {
    Object.keys(state.nodeData).forEach(key => {
      if (Number(key) > level) {
        Vue.delete(state.nodeData, key)
      }
    })
  }

  function isSelected(code) {
    return _.includes(_.map(state.nodeData, val => val.node.code), code)
  }

  function resetNodeData() {
    state.nodeData = _.cloneDeep(state.selectedNodeData)
  }

  function saveSelectedNodeData() {
    state.selectedNodeData = _.cloneDeep(state.nodeData)
  }

  return {
    ...toRefs(state),
    selectionNames,
    hasSelections,
    lastLevel,
    deepestNodeSelection,
    endOfNodeHierarchy,
    isModelSelected,
    hasChanges,
    resetLowerLevels,
    addLevel,
    isSelected,
    resetNodeData,
    saveSelectedNodeData,
    getNodeCodeHierarchy,
    prePopulateSelections
  }
}
